import App from './App'
import '../styles/index.scss';

const app = new App()

if (process.env.NODE_ENV === 'development') {

}

